export class NiveauEtude {
    id: number;
    name: string;
}


